/* eslint-disable */

import React from 'react';
import './style.css';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { getWeboConfig } from '../../utils';
import { FlexDivCenter } from '../../components/Typography/Typography';
/* App.jsx */

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
  }

  handleMenuClick() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  handleLinkClick(key) {
    if (key === '/logout') {
      axios.post('/reservations/v1/logout').then(() => {
        window.location.reload();
      });
    }
    this.props.history.push(key);
    this.setState({ menuOpen: false });
  }

  render() {
    const styles = {
      container: {
        zIndex: '999999999',
        position: 'relative',
        padding: '10px 0',
        opacity: 0.98,
        display: 'flex',
        alignItems: 'center',
        background: '#FFF',
        width: '100%',
        color: '#1D3D7D',
        fontFamily: 'Assistant',
      },
      logo: {
        margin: '0 auto',
      },
      body: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        filter: this.state.menuOpen ? 'blur(2px)' : null,
        transition: 'filter 0.5s ease',
      },
    };
    const menu = [
      // { name: 'מתנות', key: '/gift' },
      { name: 'השאלת ציוד', key: '/rent', display: getWeboConfig('SHOW_RENT') },
      { name: 'מתנות', key: '/gift', display: getWeboConfig('SHOW_GIFTS_V2') },
      { name: 'אירועים', key: '/', display: !getWeboConfig('HIDE_EVENT') },
      {
        name: 'יצירת כרטיס סטודנט',
        key: '/student-card',
        display: getWeboConfig('SHOW_CREATE_STUDENT_CARD'),
      },
      {
        name: 'חנות האגודה',
        key: '/services',
        display: getWeboConfig('SG_SERVICES'),
      },
      { key: '/contact', name: 'צור קשר', display: true },
      { key: '/logout', name: 'התנתק', display: true },
    ].filter((item) => !!item.display);
    const menuItems = menu.map((val, index) => {
      return (
        <MenuItem
          key={index}
          delay={`${index * 0.1}s`}
          onClick={() => {
            this.handleLinkClick(val.key);
          }}
        >
          {val.name}
        </MenuItem>
      );
    });

    return (
      <div style={{ zIndex: 9999999 }}>
        <div style={styles.container}>
          <FlexDivCenter>
            <div style={{ position: 'absolute', left: '3%' }}>
              <MenuButton
                open={this.state.menuOpen}
                onClick={() => this.handleMenuClick()}
                color="#1D3D7D"
              />
            </div>
            <img
              width={getWeboConfig('LOGO_WIDTH') || '220px'}
              src={getWeboConfig('STORE_LOGO')}
              alt="logo"
            />
          </FlexDivCenter>
          <div style={styles.logo} />
        </div>
        <Menu open={this.state.menuOpen}>
          <FlexDivCenter>{getWeboConfig('hebrew_name')}</FlexDivCenter>
          {menuItems}
        </Menu>
      </div>
    );
  }
}

/* MenuItem.jsx */
class MenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }

  handleHover() {
    this.setState({ hover: !this.state.hover });
  }

  render() {
    const styles = {
      container: {
        opacity: 0,
        animation: '1s appear forwards',
        animationDelay: this.props.delay,
      },
      menuItem: {
        fontFamily: `'Assistant'`,
        fontSize: '1.2rem',
        padding: '1rem 0',
        margin: '0 5%',
        cursor: 'pointer',
        color: this.state.hover ? 'gray' : '#fafafa',
        transition: 'color 0.2s ease-in-out',
        animation: '0.5s slideIn forwards',
        animationDelay: this.props.delay,
      },
      line: {
        width: '90%',
        height: '1px',
        background: 'gray',
        margin: '0 auto',
        animation: '0.5s shrink forwards',
        animationDelay: this.props.delay,
      },
    };
    return (
      <div style={styles.container}>
        <div
          style={styles.menuItem}
          onMouseEnter={() => {
            this.handleHover();
          }}
          onMouseLeave={() => {
            this.handleHover();
          }}
          onClick={this.props.onClick}
        >
          {this.props.children}
        </div>
        <div style={styles.line} />
      </div>
    );
  }
}

/* Menu.jsx */
class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open ? this.props.open : false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      this.setState({ open: nextProps.open });
    }
  }

  render() {
    const styles = {
      container: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: this.state.open ? '100%' : 0,
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        background: '#31518A',
        opacity: 0.98,
        color: '#fafafa',
        transition: 'height 0.3s ease',
        zIndex: 99999,
      },
      menuList: {
        paddingTop: '3rem',
      },
    };
    return (
      <div style={styles.container}>
        {this.state.open ? (
          <div style={styles.menuList}>
            <FlexDivCenter style={{ color: '#1D3D7D', marginBottom: 10 }}>
              .
            </FlexDivCenter>
            {this.props.children}
          </div>
        ) : null}
      </div>
    );
  }
}

/* MenuButton.jsx */
class MenuButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open ? this.props.open : false,
      color: this.props.color ? this.props.color : '#1D3D7D',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      this.setState({ open: nextProps.open });
    }
  }

  handleClick() {
    this.setState({ open: !this.state.open });
  }

  render() {
    const styles = {
      container: {
        height: '32px',
        width: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        padding: '4px',
      },
      line: {
        height: '2px',
        width: '20px',
        background: this.state.color,
        transition: 'all 0.2s ease',
      },
      lineTop: {
        transform: this.state.open ? 'rotate(45deg)' : 'none',
        transformOrigin: 'top left',
        marginBottom: '5px',
      },
      lineMiddle: {
        opacity: this.state.open ? 0 : 1,
        transform: this.state.open ? 'translateX(-16px)' : 'none',
      },
      lineBottom: {
        transform: this.state.open ? 'translateX(-1px) rotate(-45deg)' : 'none',
        transformOrigin: 'top left',
        marginTop: '5px',
      },
    };
    return (
      <div
        style={styles.container}
        onClick={
          this.props.onClick
            ? this.props.onClick
            : () => {
              this.handleClick();
            }
        }
      >
        <div style={{ ...styles.line, ...styles.lineTop }} />
        <div style={{ ...styles.line, ...styles.lineMiddle }} />
        <div style={{ ...styles.line, ...styles.lineBottom }} />
      </div>
    );
  }
}

/* Footer.jsx */
function Footer(props) {
  const styles = {
    footer: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      marginTop: '1rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      color: props.color,
    },
    line: {
      height: '1px',
      width: '90%',
      background: props.color,
    },
    text: {
      padding: '0.5rem',
    },
  };

  return (
    <div style={styles.footer}>
      <div style={styles.line} />
      <div style={styles.text}>
        {props.title} created by Smashcat &copy; 2017
      </div>
    </div>
  );
}

// Footer.defaultProps = {
//   color: '#1D3D7D',
//   title: 'hello world!'
// };

// Footer.propTypes = {
//   color: React.PropTypes.string,
//   title: React.PropTypes.string,
// };

/* Main.jsx */
class Main extends React.Component {
  render() {
    const styles = {
      main: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100vh',
        zIndex: 999999,
      },
    };

    return (
      <div style={styles.main}>
        <App />
      </div>
    );
  }
}

export default withRouter(App);
